var _g, _g2, _g3, _g4, _g5, _g6, _g7, _path, _path2, _path3, _path4, _path5, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardArtistMobileBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 393 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2903_15747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.067 94.8143C318.321 94.8143 318.528 94.5513 318.528 94.2269C318.528 93.9026 318.321 93.6396 318.067 93.6396C317.813 93.6396 317.606 93.9026 317.606 94.2269C317.606 94.5513 317.813 94.8143 318.067 94.8143Z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2903_15747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.947 65.4488C343.201 65.4488 343.408 65.1859 343.408 64.8615C343.408 64.5371 343.201 64.2741 342.947 64.2741C342.692 64.2741 342.486 64.5371 342.486 64.8615C342.486 65.1859 342.692 65.4488 342.947 65.4488Z",
    fill: "#D9D9D9",
    fillOpacity: 0.4
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2903_15747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.418 26.0971C384.672 26.0971 384.879 25.8342 384.879 25.5098C384.879 25.1854 384.672 24.9224 384.418 24.9224C384.163 24.9224 383.957 25.1854 383.957 25.5098C383.957 25.8342 384.163 26.0971 384.418 26.0971Z",
    fill: "#D9D9D9",
    fillOpacity: 0.4
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_2903_15747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.042 144.738C107.297 144.738 107.503 144.475 107.503 144.151C107.503 143.827 107.297 143.564 107.042 143.564C106.788 143.564 106.582 143.827 106.582 144.151C106.582 144.475 106.788 144.738 107.042 144.738Z",
    fill: "#D9D9D9"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_2903_15747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.90167 114.784C9.15614 114.784 9.36243 114.521 9.36243 114.197C9.36243 113.872 9.15614 113.609 8.90167 113.609C8.64721 113.609 8.44092 113.872 8.44092 114.197C8.44092 114.521 8.64721 114.784 8.90167 114.784Z",
    fill: "#D9D9D9"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_2903_15747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.8895 122.419C62.1439 122.419 62.3502 122.156 62.3502 121.832C62.3502 121.507 62.1439 121.244 61.8895 121.244C61.635 121.244 61.4287 121.507 61.4287 121.832C61.4287 122.156 61.635 122.419 61.8895 122.419Z",
    fill: "#D9D9D9"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_2903_15747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.92 54.8771C267.174 54.8771 267.38 54.6141 267.38 54.2898C267.38 53.9654 267.174 53.7024 266.92 53.7024C266.665 53.7024 266.459 53.9654 266.459 54.2898C266.459 54.6141 266.665 54.8771 266.92 54.8771Z",
    fill: "#D9D9D9",
    fillOpacity: 0.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    },
    filter: "url(#filter7_d_2903_15747)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7708 94.2281C40.0253 94.2281 40.2316 93.9651 40.2316 93.6407C40.2316 93.3164 40.0253 93.0534 39.7708 93.0534C39.5164 93.0534 39.3101 93.3164 39.3101 93.6407C39.3101 93.9651 39.5164 94.2281 39.7708 94.2281Z",
    fill: "#D9D9D9",
    fillOpacity: 0.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "hard-light"
    },
    filter: "url(#filter8_d_2903_15747)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.33 19.0481C27.5845 19.0481 27.7908 18.7852 27.7908 18.4608C27.7908 18.1364 27.5845 17.8735 27.33 17.8735C27.0756 17.8735 26.8693 18.1364 26.8693 18.4608C26.8693 18.7852 27.0756 19.0481 27.33 19.0481Z",
    fill: "#D9D9D9",
    fillOpacity: 0.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    filter: "url(#filter9_d_2903_15747)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6861 51.9392C87.9406 51.9392 88.1469 51.6762 88.1469 51.3518C88.1469 51.0274 87.9406 50.7645 87.6861 50.7645C87.4316 50.7645 87.2253 51.0274 87.2253 51.3518C87.2253 51.6762 87.4316 51.9392 87.6861 51.9392Z",
    fill: "#D9D9D9",
    fillOpacity: 0.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    filter: "url(#filter10_d_2903_15747)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M146.669 36.6688C146.923 36.6688 147.129 36.4059 147.129 36.0815C147.129 35.7571 146.923 35.4942 146.669 35.4942C146.414 35.4942 146.208 35.7571 146.208 36.0815C146.208 36.4059 146.414 36.6688 146.669 36.6688Z",
    fill: "#D9D9D9",
    fillOpacity: 0.8
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    filter: "url(#filter11_d_2903_15747)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M226.836 26.6833C227.091 26.6833 227.297 26.4203 227.297 26.096C227.297 25.7716 227.091 25.5086 226.836 25.5086C226.582 25.5086 226.376 25.7716 226.376 26.096C226.376 26.4203 226.582 26.6833 226.836 26.6833Z",
    fill: "#D9D9D9",
    fillOpacity: 0.8
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_d_2903_15747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.9221 104.213C85.1766 104.213 85.3829 103.95 85.3829 103.626C85.3829 103.301 85.1766 103.038 84.9221 103.038C84.6677 103.038 84.4614 103.301 84.4614 103.626C84.4614 103.95 84.6677 104.213 84.9221 104.213Z",
    fill: "#D9D9D9",
    fillOpacity: 0.4
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_d_2903_15747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.899 104.213C144.153 104.213 144.36 103.95 144.36 103.626C144.36 103.301 144.153 103.038 143.899 103.038C143.645 103.038 143.438 103.301 143.438 103.626C143.438 103.95 143.645 104.213 143.899 104.213Z",
    fill: "#D9D9D9",
    fillOpacity: 0.4
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_d_2903_15747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.468 140.04C172.722 140.04 172.929 139.777 172.929 139.452C172.929 139.128 172.722 138.865 172.468 138.865C172.213 138.865 172.007 139.128 172.007 139.452C172.007 139.777 172.213 140.04 172.468 140.04Z",
    fill: "#D9D9D9"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_d_2903_15747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.734 88.9426C286.989 88.9426 287.195 88.6796 287.195 88.3552C287.195 88.0309 286.989 87.7679 286.734 87.7679C286.48 87.7679 286.273 88.0309 286.273 88.3552C286.273 88.6796 286.48 88.9426 286.734 88.9426Z",
    fill: "#D9D9D9",
    fillOpacity: 0.4
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_d_2903_15747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.243 34.9075C351.498 34.9075 351.704 34.6445 351.704 34.3201C351.704 33.9957 351.498 33.7328 351.243 33.7328C350.989 33.7328 350.782 33.9957 350.782 34.3201C350.782 34.6445 350.989 34.9075 351.243 34.9075Z",
    fill: "#D9D9D9"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_d_2903_15747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.198 113.023C240.452 113.023 240.659 112.76 240.659 112.435C240.659 112.111 240.452 111.848 240.198 111.848C239.943 111.848 239.737 112.111 239.737 112.435C239.737 112.76 239.943 113.023 240.198 113.023Z",
    fill: "#D9D9D9"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_d_2903_15747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.669 68.9729C146.923 68.9729 147.129 68.71 147.129 68.3856C147.129 68.0612 146.923 67.7983 146.669 67.7983C146.414 67.7983 146.208 68.0612 146.208 68.3856C146.208 68.71 146.414 68.9729 146.669 68.9729Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_d_2903_15747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.536 66.6226C177.791 66.6226 177.997 66.3596 177.997 66.0352C177.997 65.7109 177.791 65.4479 177.536 65.4479C177.282 65.4479 177.075 65.7109 177.075 66.0352C177.075 66.3596 177.282 66.6226 177.536 66.6226Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_d_2903_15747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.377 70.7343C226.631 70.7343 226.837 70.4713 226.837 70.147C226.837 69.8226 226.631 69.5596 226.377 69.5596C226.122 69.5596 225.916 69.8226 225.916 70.147C225.916 70.4713 226.122 70.7343 226.377 70.7343Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_f_2903_15747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.846 59.5147C77.4933 59.5147 -5.5186 26.5036 -24.8064 55.5751V187.16H367.379V-11.7479C352.682 -19.9084 310.617 -34.0869 259.919 -25.5185C196.543 -14.8081 182.199 59.5147 129.846 59.5147Z",
    fill: "url(#paint0_linear_2903_15747)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.909 62.6223C184.262 62.6223 267.272 30.4153 286.561 58.7786V187.161H-105.624V-6.90491C-90.9285 -14.8667 -48.8627 -28.7001 1.83675 -20.3403C65.2108 -9.89077 79.5565 62.6223 131.909 62.6223Z",
    fill: "url(#paint1_linear_2903_15747)",
    fillOpacity: 0.5
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.76333 199.925C1.40945 190.082 0.318359 182.147 0.318359 182.147C0.318359 182.147 1.40945 190.087 2.76333 199.925ZM2.76333 199.925L5.20597 217.702",
    stroke: "url(#paint2_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2132 217.268L12.3654 199.925L7.51758 182.582",
    stroke: "url(#paint3_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7948 183.311L21.9686 199.925L29.1401 216.551",
    stroke: "url(#paint4_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.949 215.564C40.949 215.564 36.7608 208.579 31.5682 199.925L22.1875 184.285",
    stroke: "url(#paint5_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7363 185.524L41.1753 199.924L52.6117 214.324",
    stroke: "url(#paint6_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0786 212.85L50.7749 199.925L37.4688 187.001",
    stroke: "url(#paint7_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.418 188.686L60.3806 199.925L75.3408 211.163",
    stroke: "url(#paint8_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.357 209.295L69.9833 199.925L53.6172 190.554",
    stroke: "url(#paint9_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0664 192.575L79.5833 199.925L97.0999 207.275",
    stroke: "url(#paint10_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.564 205.133L89.1897 199.925L70.8125 194.718",
    stroke: "url(#paint11_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8516 196.949L98.7941 199.925L117.732 202.9",
    stroke: "url(#paint12_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.586 200.638L108.396 199.924L89.2051 199.21",
    stroke: "url(#paint13_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8652 201.497L117.996 199.925L137.13 198.353",
    stroke: "url(#paint14_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.361 196.094L127.599 199.925L108.838 203.756",
    stroke: "url(#paint15_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.113 205.953L137.2 199.924L155.287 193.896",
    stroke: "url(#paint16_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.921 191.799L146.811 199.925L129.701 208.051",
    stroke: "url(#paint17_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.535 210.018L156.405 199.925L172.275 189.833",
    stroke: "url(#paint18_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.38 188.022L166.012 199.925L151.645 211.828",
    stroke: "url(#paint19_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.984 213.429L175.614 199.924C182.608 192.451 188.241 186.42 188.241 186.42",
    stroke: "url(#paint20_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.9 185.029L185.216 199.925L174.533 214.821",
    stroke: "url(#paint21_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.252 215.966L194.819 199.925L203.385 183.884",
    stroke: "url(#paint22_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.733 182.996C210.733 182.996 207.902 190.557 204.432 199.925L198.123 216.854",
    stroke: "url(#paint23_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.027 199.925C211.84 209.631 210.076 217.467 210.076 217.467C210.076 217.467 211.842 209.631 214.027 199.925ZM214.027 199.925C216.214 190.22 217.976 182.384 217.976 182.384C217.976 182.384 216.212 190.22 214.027 199.925Z",
    stroke: "url(#paint24_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.155 182.071C225.155 182.071 224.474 190.051 223.626 199.938C222.781 209.824 222.102 217.804 222.102 217.804C222.102 217.804 222.781 209.812 223.626 199.925C224.474 190.039 225.155 182.071 225.155 182.071Z",
    stroke: "url(#paint25_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.152 217.828C234.152 217.828 233.742 209.83 233.232 199.924C232.719 190.018 232.309 182.02 232.309 182.02",
    stroke: "url(#paint26_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.835 199.924C240.968 190.159 239.479 182.276 239.479 182.276C239.479 182.276 240.978 190.159 242.835 199.924ZM242.835 199.924L246.186 217.573",
    stroke: "url(#paint27_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.438 199.925C255.611 209.393 258.171 217.035 258.171 217.035C258.171 217.035 255.611 209.391 252.438 199.925ZM252.438 199.925L246.703 182.815",
    stroke: "url(#paint28_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.025 183.638C254.025 183.638 257.605 190.913 262.044 199.925L270.064 216.211L262.038 199.925C257.601 190.913 254.025 183.638 254.025 183.638Z",
    stroke: "url(#paint29_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.815 215.128C281.815 215.128 277.272 208.336 271.648 199.925L261.48 184.722L271.631 199.925C277.272 208.336 281.815 215.128 281.815 215.128Z",
    stroke: "url(#paint30_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.078 186.054L281.243 199.925L293.395 213.797",
    stroke: "url(#paint31_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.805 212.239L290.848 199.925L276.893 187.61",
    stroke: "url(#paint32_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.928 189.369L300.452 199.925L315.972 210.481",
    stroke: "url(#paint33_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.886 208.553L310.053 199.926L293.217 191.299",
    stroke: "url(#paint34_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.783 193.368L319.657 199.925L337.53 206.481",
    stroke: "url(#paint35_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.882 204.307L329.26 199.925L310.635 195.544",
    stroke: "url(#paint36_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.793 197.79L338.863 199.925L357.932 202.06",
    stroke: "url(#paint37_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.669 199.778L348.466 199.925L329.26 200.071",
    stroke: "url(#paint38_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.037 202.349L358.066 199.924L377.096 197.499",
    stroke: "url(#paint39_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.215 195.258L367.671 199.925L349.129 204.591",
    stroke: "url(#paint40_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.518 206.755L377.266 199.926L395.025 193.097",
    stroke: "url(#paint41_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.554 191.042L386.878 199.924L370.197 208.807",
    stroke: "url(#paint42_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.145 210.717L396.477 199.925L411.812 189.134",
    stroke: "url(#paint43_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.822 187.399L406.084 199.924L392.346 212.45",
    stroke: "url(#paint44_linear_2903_15747)",
    strokeWidth: 0.0818305,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2903_15747",
    x: 315.763,
    y: 93.6396,
    width: 4.60756,
    height: 4.86072,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.84302
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.921512
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2903_15747"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2903_15747",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2903_15747",
    x: 340.643,
    y: 64.2741,
    width: 4.60756,
    height: 4.86072,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.84302
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.921512
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2903_15747"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2903_15747",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2903_15747",
    x: 382.114,
    y: 24.9224,
    width: 4.60756,
    height: 4.86072,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.84302
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.921512
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2903_15747"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2903_15747",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_2903_15747",
    x: 104.738,
    y: 143.564,
    width: 4.60756,
    height: 4.86072,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.84302
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.921512
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2903_15747"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2903_15747",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_2903_15747",
    x: 6.59789,
    y: 113.609,
    width: 4.60756,
    height: 4.86072,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.84302
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.921512
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2903_15747"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2903_15747",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_2903_15747",
    x: 59.5857,
    y: 121.244,
    width: 4.60756,
    height: 4.86072,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.84302
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.921512
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2903_15747"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2903_15747",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_2903_15747",
    x: 264.616,
    y: 53.7024,
    width: 4.60756,
    height: 4.86072,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.84302
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.921512
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2903_15747"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2903_15747",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_2903_15747",
    x: 37.467,
    y: 93.0534,
    width: 4.60756,
    height: 4.86072,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.84302
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.921512
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2903_15747"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2903_15747",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_2903_15747",
    x: 25.0262,
    y: 17.8735,
    width: 4.60756,
    height: 4.86072,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.84302
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.921512
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2903_15747"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2903_15747",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_2903_15747",
    x: 85.3823,
    y: 50.7645,
    width: 4.60756,
    height: 4.86072,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.84302
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.921512
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2903_15747"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2903_15747",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_2903_15747",
    x: 144.365,
    y: 35.4942,
    width: 4.60756,
    height: 4.86072,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.84302
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.921512
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2903_15747"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2903_15747",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_2903_15747",
    x: 224.533,
    y: 25.5086,
    width: 4.60756,
    height: 4.86072,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.84302
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.921512
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2903_15747"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2903_15747",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_2903_15747",
    x: 82.6183,
    y: 103.038,
    width: 4.60756,
    height: 4.86072,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.84302
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.921512
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2903_15747"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2903_15747",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_2903_15747",
    x: 141.595,
    y: 103.038,
    width: 4.60756,
    height: 4.86072,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.84302
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.921512
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2903_15747"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2903_15747",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_d_2903_15747",
    x: 170.164,
    y: 138.865,
    width: 4.60756,
    height: 4.86072,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.84302
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.921512
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2903_15747"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2903_15747",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_d_2903_15747",
    x: 284.43,
    y: 87.7679,
    width: 4.60756,
    height: 4.86072,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.84302
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.921512
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2903_15747"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2903_15747",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d_2903_15747",
    x: 348.939,
    y: 33.7328,
    width: 4.60756,
    height: 4.86072,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.84302
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.921512
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2903_15747"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2903_15747",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_d_2903_15747",
    x: 237.894,
    y: 111.848,
    width: 4.60756,
    height: 4.86072,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.84302
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.921512
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2903_15747"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2903_15747",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_d_2903_15747",
    x: 144.365,
    y: 67.7983,
    width: 4.60756,
    height: 4.86072,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.84302
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.921512
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2903_15747"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2903_15747",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_d_2903_15747",
    x: 175.232,
    y: 65.4479,
    width: 4.60756,
    height: 4.86072,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.84302
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.921512
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2903_15747"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2903_15747",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_d_2903_15747",
    x: 224.073,
    y: 69.5596,
    width: 4.60756,
    height: 4.86072,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.84302
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.921512
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2903_15747"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2903_15747",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_f_2903_15747",
    x: -140.134,
    y: -62.6875,
    width: 542.024,
    height: 284.358,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.2552,
    result: "effect1_foregroundBlur_2903_15747"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2903_15747",
    x1: 3.18146,
    y1: 103.77,
    x2: 317.078,
    y2: 103.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C00079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2903_15747",
    x1: 375.179,
    y1: 99.1389,
    x2: -179.094,
    y2: 98.1164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2489E2",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C54FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2903_15747",
    x1: -1.04038,
    y1: 182.147,
    x2: 7.90834,
    y2: 182.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2903_15747",
    x1: 4.82199,
    y1: 182.582,
    x2: 22.5673,
    y2: 182.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2903_15747",
    x1: 10.8069,
    y1: 183.311,
    x2: 37.0433,
    y2: 184.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2903_15747",
    x1: 16.9717,
    y1: 184.285,
    x2: 51.247,
    y2: 185.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2903_15747",
    x1: 23.377,
    y1: 185.524,
    x2: 65.0948,
    y2: 188.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2903_15747",
    x1: 30.0713,
    y1: 187.001,
    x2: 78.4656,
    y2: 191.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2903_15747",
    x1: 37.0996,
    y1: 188.687,
    x2: 91.2708,
    y2: 194.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2903_15747",
    x1: 44.5156,
    y1: 190.554,
    x2: 103.305,
    y2: 198.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2903_15747",
    x1: 52.3272,
    y1: 192.575,
    x2: 114.203,
    y2: 204.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2903_15747",
    x1: 60.5954,
    y1: 194.718,
    x2: 122.873,
    y2: 212.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2903_15747",
    x1: 69.321,
    y1: 196.949,
    x2: 124.272,
    y2: 225.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2903_15747",
    x1: 78.5351,
    y1: 199.21,
    x2: 90.9201,
    y2: 225.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2903_15747",
    x1: 88.2278,
    y1: 198.353,
    x2: 123.999,
    y2: 233.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2903_15747",
    x1: 98.4064,
    y1: 196.094,
    x2: 157.882,
    y2: 219.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2903_15747",
    x1: 109.057,
    y1: 193.896,
    x2: 171.649,
    y2: 209.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2903_15747",
    x1: 120.188,
    y1: 191.799,
    x2: 181.102,
    y2: 202.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2903_15747",
    x1: 131.711,
    y1: 189.833,
    x2: 188.916,
    y2: 197.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2903_15747",
    x1: 143.656,
    y1: 188.022,
    x2: 195.782,
    y2: 193.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2903_15747",
    x1: 155.963,
    y1: 186.42,
    x2: 201.949,
    y2: 189.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2903_15747",
    x1: 168.593,
    y1: 185.029,
    x2: 207.591,
    y2: 187.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2903_15747",
    x1: 181.49,
    y1: 183.884,
    x2: 212.803,
    y2: 185.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2903_15747",
    x1: 194.619,
    y1: 182.996,
    x2: 217.688,
    y2: 183.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2903_15747",
    x1: 207.88,
    y1: 182.384,
    x2: 222.341,
    y2: 182.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2903_15747",
    x1: 221.254,
    y1: 182.071,
    x2: 226.844,
    y2: 182.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2903_15747",
    x1: 231.794,
    y1: 182.021,
    x2: 235.173,
    y2: 182.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2903_15747",
    x1: 237.615,
    y1: 182.276,
    x2: 249.894,
    y2: 182.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2903_15747",
    x1: 243.516,
    y1: 182.815,
    x2: 264.498,
    y2: 183.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2903_15747",
    x1: 249.566,
    y1: 183.638,
    x2: 278.89,
    y2: 184.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2903_15747",
    x1: 255.829,
    y1: 184.722,
    x2: 292.955,
    y2: 186.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2903_15747",
    x1: 262.319,
    y1: 186.054,
    x2: 306.625,
    y2: 189.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2903_15747",
    x1: 269.133,
    y1: 187.61,
    x2: 319.825,
    y2: 192.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2903_15747",
    x1: 276.299,
    y1: 189.369,
    x2: 332.359,
    y2: 196.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2903_15747",
    x1: 283.858,
    y1: 191.299,
    x2: 344.027,
    y2: 200.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2903_15747",
    x1: 291.844,
    y1: 193.368,
    x2: 354.3,
    y2: 207.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2903_15747",
    x1: 300.279,
    y1: 195.544,
    x2: 361.343,
    y2: 216.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2903_15747",
    x1: 309.19,
    y1: 197.79,
    x2: 355.245,
    y2: 230.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2903_15747",
    x1: 318.581,
    y1: 199.778,
    x2: 319.205,
    y2: 206.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2903_15747",
    x1: 328.456,
    y1: 197.499,
    x2: 378.286,
    y2: 228.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2903_15747",
    x1: 338.817,
    y1: 195.258,
    x2: 400.432,
    y2: 214.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2903_15747",
    x1: 349.647,
    y1: 193.097,
    x2: 411.94,
    y2: 206.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2903_15747",
    x1: 360.924,
    y1: 191.042,
    x2: 420.643,
    y2: 200.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2903_15747",
    x1: 372.619,
    y1: 189.134,
    x2: 428.05,
    y2: 195.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2903_15747",
    x1: 384.707,
    y1: 187.399,
    x2: 434.63,
    y2: 191.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337048,
    stopColor: "#8C54FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA101"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardArtistMobileBg);
export default __webpack_public_path__ + "static/media/dashboardArtistMobileBg.53edfcaeb0cc0eae0a3cf4817ce1a4f6.svg";
export { ForwardRef as ReactComponent };